// Cabecera del hero del landing: SOLO los overlays satelitales (recorte
// animado de costas, nubes que derivan, destello solar, halo atmosférico y
// barrido de escaneo) en CSS/SVG puro. El mapa base (relieve + rutas + hubs)
// lo pinta el fondo global (LogisticsMapBackground variant="landing") detrás
// de toda la página, así no se renderiza dos veces.
// Cabecera del hero: overlays satelitales (destello solar, halo atmosférico y
// barrido de escaneo) sobre el mapa satelital real del fondo global. Sin
// contornos vectoriales (la tierra ya viene del mapa real) ni doble línea.
import "@/components/logistics-map.css";

export default function LogisticsHeroMap() {
  return (
    <div className="logi-hero absolute inset-0 overflow-hidden">
      <div className="logi-glint" />
      <div className="logi-atmo" />
    </div>
  );
}